<template>
 <div class="news">
      <Menu></Menu>
      <!-- <div class="content" ref="text">
      <div class="title">
          <p>{{data.title}}</p>
          <span>{{data.createTime |seTimeFilter('sq')}}</span>
      </div>
      </div> -->
  </div>
</template>

<script>
import Menu from '../../components/menu/menu.vue'

export default {
components: { Menu },
  data(){
     return {
         data:'',
         text:''
     }
  },
  created(){
      console.log('this.$router',this.$route);
      this.data = this.$route.params.data||''
      this.text = this.$route.params.data?decodeURI(this.$route.params.data.content):''
  },
  mounted(){
      
console.log('(this.text',this.text);
      this.$refs['text'].innerHTML+= this.text
  },
  methods:{
      
  }
}
</script>

<style lang="less" scoped>
.content{
    width: 1200px;
    margin: 70px auto 0;
}
.title{
    margin-bottom: 60px;
}
.title p{
    font-size: 18px;
}
.title span{
    color:#666;
    font-size: 14px;
    display: block;
    margin-top: 8px;
}
</style>